import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { IconStyle, LabelIconStyle } from '../../../utils/DataCatalogUtils';
import { DataSource } from '../../../models/SearchResultTypes';
import { DataSourceType } from './DataSourceType';
import { LinkCell } from './LinkCell';
import { LabelWrapper } from './Labels';
import { SessionManagementService } from '../../../services/SessionManagementService';

export function DataSourceNameCell(parameters: IColumnFactoryParameters): React.Factory<BodyCell.Props> {
  return React.createFactory(function DataSourceNameCell(props: BodyCell.Props) {
    const linkCellFactory = LinkCell(
      parameters.generateLinkForName,
      true,
      parameters.listViewParams.urls,
      parameters.listViewParams.searchTerm,
      parameters.listViewParams.total
    );

    const labels = LabelWrapper(
      {
        catalogEnabled: SessionManagementService.instance.catalogingOnSiteEnabled(),
        content: {
          contentId: props.row.data.id,
          contentLuid: props.row.data.crassData?.datasourceLuid,
          contentType: 'datasource',
          contentName: props.row.data.name,
          subjectArea: 'datasource',
        },
        includeUpstream: false,
        includeParented: false,
        probablyOrEager: {
          certified: props.row.data.crassData?.isCertified,
          warning: props.row.data.crassData?.hasActiveDataQualityWarning
            ? { count: 1, value: 'Warning', severe: props.row.data.crassData.hasSevereDataQualityWarning }
            : undefined,
        },
        testId: 'datasource-search-label',
        controls: {
          kind: 'icon',
          siteUrls: parameters.listViewParams.urls,
        },
      },
      parameters.listViewParams.urls,
      props.row.data.crassData?.siteLuid
    );

    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        <div className={IconStyle} style={{ paddingLeft: '3px' }}>
          <DataSourceType data={props.row.data as DataSource} urls={parameters.listViewParams.urls}></DataSourceType>
        </div>
        <div className={LabelIconStyle}>{labels}</div>
        <div className={IconStyle}>{linkCellFactory(props)}</div>
      </div>
    );
  });
}
